import { Cover, SelectedFile } from "@/types/types";

export const isSelectedCover = (
  coverMaybe: SelectedFile | Cover
): coverMaybe is Cover => {
  return "thumbnailUrl" in coverMaybe;
};
